module.exports = __webpack_public_path__ + "static/media/importICloud1.1be9f3bf.png";